import PropTypes from 'prop-types';
import pick from 'lodash.pick';

/**
 * Full shape of overview stats
 */
const Shape = {
  flows_shown: PropTypes.number,
  distinct_users_reached: PropTypes.number,
  prev_flows_shown: PropTypes.number,
  prev_distinct_users_reached: PropTypes.number,
};

/**
 * Allowed fields for storage
 */
const allowed = ['flows_shown'];

/**
 * Overview stats parsing function
 *
 * @param {Object<keyof Overview>} overview - Object with overview fields
 * @return {Object<keyof Overview>} Object with parsed overview fields
 */
export const parse = overview => pick(overview, allowed);

export default PropTypes.shape(parse(Shape));
